import React from 'react';
import {
  Container,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
} from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './Skills.scss';

const Skills = () => {
  const skillCategories = [
    {
      title: 'Programming Languages',
      skills: ['C#', 'Java', 'Python', 'JavaScript', 'TypeScript', 'HTML5', 'CSS3']
    },
    {
      title: 'Web Development',
      skills: ['Angular', 'React.js', 'Node.js', 'Python Flask']
    },
    {
      title: 'Back-end Development',
      skills: ['.NET', 'ASP.NET Core Web API', 'ASP.NET MVC', '.NET ORM tools', '.NET EF Core', 'Auto Mapper', 'Kafka', 'Node.js', 'Python Flask']
    },
    {
      title: 'Database',
      skills: ['MySQL', 'MongoDB', 'DynamoDB', 'SQLite']
    },
    {
      title: 'AI/ML Frameworks/Libraries',
      skills: ['Claude code', 'Open AI', 'PyTorch', 'Transformers', 'scikit-learn', 'SciPy', 'NumPy', 'Matplotlib', 'itertools', 'MLxtend']
    },
    {
      title: 'Cloud Services',
      skills: ['Azure Blob', 'AppService', 'DataFactory', 'Functions', 'API Gateway', 'ServiceBus', 'AWS S3', 'DynamoDB', 'VPC', 'Lambda', 'API Gateway', 'SQS']
    },
    {
      title: 'Tools',
      skills: ['Git', 'Azure DevOps', 'Bitbucket', 'Docker', 'Kubernetes', 'Postman', 'Chrome DevTools', 'Lighthouse']
    }
  ];

  return (
    <section id="skills" className="skills-section">
      <Container maxWidth="lg">
        <Typography variant="h2" className="section-title" gutterBottom>
          Technical Skills
        </Typography>
        <Box className="section-divider" />
        <Box className="skills-accordion-list">
          {skillCategories.map((category, index) => (
            <Accordion key={index} className="skill-accordion" defaultExpanded={false}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                className="skill-summary"
              >
                <CodeIcon className="category-icon" />
                <Typography variant="subtitle1" className="category-title">
                  {category.title}
                </Typography>
                <Box component="span" className="skill-count-badge" aria-label={`${category.skills.length} skills`}>
                  {category.skills.length}
                </Box>
              </AccordionSummary>
              <AccordionDetails className="skill-details">
                <Box className="skills-chips">
                  {category.skills.map((skill, idx) => (
                    <Chip
                      key={idx}
                      label={skill}
                      className="skill-chip"
                      variant="outlined"
                    />
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </section>
  );
};

export default Skills;
